import { UserData } from '@wwe-portal/entities/user.type';
import { S3_USERS_IMAGE } from './config';

// const renderAvatar = (): string => {
//   const isProfilePage = true;
//   if (isProfilePage) {
//     return userId
//       ? currentUser && currentUser.userId === userId
//         ? `${S3_USERS_IMAGE}/${userId}.jpg?time=${new Date().getTime()}`
//         : `${S3_USERS_IMAGE}/${userId}.jpg`
//       : TheRock;
//   }

//   return currentUser?.userId ? `${currentUser.profileImg}` : TheRock;
// };

export function getPlayerProfileImageUrl(
  userId: string,
  user?: UserData,
  avatarUrl?: string,
  fallback: boolean = true
): string {
  if (avatarUrl) {
    return avatarUrl;
  } else if (userId && userId.length > 0) {
    let url = `${S3_USERS_IMAGE}/${userId}.jpg`;
    if (user && user.userId === userId) {
      url += `?time=${new Date().getTime()}`;
    }
    return url;
  } else if (fallback) {
    return '/assets/images/common/the-rock.webp';
  } else {
    return `${S3_USERS_IMAGE}/${userId}.jpg`;
  }
}

export function getPlayerProfileFrameImageUrl(
  userId: string,
  user?: UserData,
  avatarFrameUrl?: string | null
): string {
  // Note: in the original code, currentUser.avatarRarity case returned null
  if (avatarFrameUrl) {
    return avatarFrameUrl;
  } else if (user && user.userId == userId) {
    return user.profileFrame ?? '';
  } else {
    return '';
  }
}
